(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bzk-campaign-copy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bzk-campaign-copy')) {
    class BzkCampaignCopy extends HTMLElement {
      connectedCallback() {
        this.formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        });
        this.refresh = this.refresh.bind(this);
        document.addEventListener('visibilitychange', this.refresh);
        document.addEventListener('DOMContentLoaded', this.refresh, { once: true });
        window.addEventListener('pageshow', this.refresh);
        this.refresh();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
        document.removeEventListener('DOMContentLoaded', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }

      refresh() {
        window.clearTimeout(this.timer);
        if (!this.isConnected) return;
        const now = new Date();
        const parts = Object.fromEntries(this.formatter.formatToParts(now).map(part => [part.type, part.value]));
        const date = `${parts.year}-${parts.month}-${parts.day}`;
        const preview = this.dataset.preview === 'true' && window.Shopify?.designMode === true;
        const active = preview || (date >= '2026-09-21' && date < '2026-10-19');
        this.toggleAttribute('data-active', active);
        this.querySelectorAll('[data-bzk-campaign-regular]').forEach(element => { element.hidden = active; });
        this.querySelectorAll('[data-bzk-campaign-offer]').forEach(element => { element.hidden = !active; });
        const elapsed = (Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second)) * 1000 + now.getMilliseconds();
        this.timer = window.setTimeout(this.refresh, Math.min(60000, Math.max(1, 86400000 - elapsed)));
      }
    }
    customElements.define('bzk-campaign-copy', BzkCampaignCopy);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bzk-cart-sunday-shipping"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bzk-cart-sunday-shipping')) {
    class BzkCartSundayShipping extends HTMLElement {
      connectedCallback() {
        this.formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        });
        this.refresh = this.refresh.bind(this);
        document.addEventListener('visibilitychange', this.refresh);
        document.addEventListener('DOMContentLoaded', this.refresh, { once: true });
        window.addEventListener('pageshow', this.refresh);
        this.refresh();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
        document.removeEventListener('DOMContentLoaded', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }

      refresh() {
        window.clearTimeout(this.timer);
        if (!this.isConnected) return;
        const now = new Date();
        const parts = Object.fromEntries(this.formatter.formatToParts(now).map(part => [part.type, part.value]));
        const localDate = `${parts.year}-${parts.month}-${parts.day}`;
        const active = localDate >= '2026-09-21' && localDate < '2026-10-19';
        this.toggleAttribute('data-active', active);
        this.querySelectorAll('[data-bzk-cart-regular]').forEach(element => { element.hidden = active; });
        this.querySelectorAll('[data-bzk-cart-offer]').forEach(element => { element.hidden = !active; });
        const elapsed = (Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second)) * 1000 + now.getMilliseconds();
        this.timer = window.setTimeout(this.refresh, Math.min(60000, Math.max(1, 86400000 - elapsed)));
      }
    }
    customElements.define('bzk-cart-sunday-shipping', BzkCartSundayShipping);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bzk-product-sunday-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bzk-product-sunday-benefits')) {
    class BzkProductSundayBenefits extends HTMLElement {
      connectedCallback() {
        this.formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
        });
        this.refresh = this.refresh.bind(this);
        document.addEventListener('visibilitychange', this.refresh);
        document.addEventListener('DOMContentLoaded', this.refresh, { once: true });
        window.addEventListener('pageshow', this.refresh);
        this.refresh();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.refresh);
        document.removeEventListener('DOMContentLoaded', this.refresh);
        window.removeEventListener('pageshow', this.refresh);
      }

      refresh() {
        window.clearTimeout(this.timer);
        if (!this.isConnected) return;
        const now = new Date();
        const parts = Object.fromEntries(this.formatter.formatToParts(now).map(part => [part.type, part.value]));
        const preview = this.dataset.preview === 'true' && window.Shopify?.designMode === true;
        const localDate = `${parts.year}-${parts.month}-${parts.day}`;
        const active = preview || (localDate >= '2026-09-21' && localDate < '2026-10-19');
        this.toggleAttribute('data-active', active);
        this.querySelectorAll('[data-bzk-product-regular]').forEach(element => { element.hidden = active; });
        this.querySelectorAll('[data-bzk-product-offer]').forEach(element => { element.hidden = !active; });
        const elapsed = (Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second)) * 1000 + now.getMilliseconds();
        this.timer = window.setTimeout(this.refresh, Math.min(60000, Math.max(1, 86400000 - elapsed)));
      }
    }
    customElements.define('bzk-product-sunday-benefits', BzkProductSundayBenefits);
  }
  } catch(e) { console.error(e); }
})();

})();
